/**
 * RealAuthGate — the login screen shown at boot when there is no session.
 *
 * Wraps AuthPages' LoginPage / RegisterPage. There is no router, so instead
 * of relying on the <a href="/login|/register"> links inside those pages we
 * flip between them with local state and forward `onSuccess` to whichever is
 * shown.
 */
import React, { useState } from 'react';
import { LoginPage, RegisterPage } from './AuthPages';

interface RealAuthGateProps {
  onSuccess: () => void;
}

type Mode = 'login' | 'register';

export const RealAuthGate: React.FC<RealAuthGateProps> = ({ onSuccess }) => {
  const [mode, setMode] = useState<Mode>('login');

  return (
    <div className="relative">
      {mode === 'login' ? (
        <LoginPage onSuccess={onSuccess} />
      ) : (
        <RegisterPage onSuccess={onSuccess} />
      )}

      <div className="flex flex-col items-center gap-1 -mt-8 pb-8 text-center">
        <button
          type="button"
          onClick={() => setMode(mode === 'login' ? 'register' : 'login')}
          className="text-fg-muted hover:text-fg-secondary text-sm underline underline-offset-2 transition-colors"
        >
          {mode === 'login'
            ? 'Need an account? Register'
            : 'Already have an account? Login'}
        </button>
      </div>
    </div>
  );
};
